import React from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import XiQLightLogo from "../../../../assets/img/Loaders/XiQLightLogo.png";
import BlogItemLoader from "../../../Common/Components/BlogItemLoader";
import AccountItemLoader from "../../../Common/Components/AccountItemLoader";
import BlogItemTwoLoader from "../../../Common/Components/BlogItemTwoLoader";
import ListPlaceholder from "../../WhatsHappeningNow/Components/ListPlaceholder";

interface IMyAccountsPlaceHolderProps {
  loading: boolean;
}

const MyAccountsPlaceHolderTop = (props: IMyAccountsPlaceHolderProps) => {
  const { loading } = props;

  return (
    <>
      {loading ? (
        <Wrapper>
          <Row gutter={24}>
            <Col className="gutter-row mb-3" sm={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
            <Col className="gutter-row mb-3" sm={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
            <Col className="gutter-row mb-3" sm={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
            <Col className="gutter-row mb-3" sm={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
            <Col
              className="gutter-row mb-3 hide-small"
              sm={{ span: 6 }}
              lg={{ span: 6 }}
              xl={{ span: 4 }}
              xxl={{ span: 4 }}
            >
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
            <Col
              className="gutter-row mb-3 hide-small"
              sm={{ span: 6 }}
              lg={{ span: 6 }}
              xl={{ span: 4 }}
              xxl={{ span: 4 }}
            >
              <div className="responsive-svg">
                <AccountItemLoader />
              </div>
            </Col>
          </Row>
        </Wrapper>
      ) : null}
    </>
  );
};

export default MyAccountsPlaceHolderTop;

const Wrapper = styled.div`
  .hide-small {
    @media all and (max-width: 1200px) {
      display: none;
    }
  }
  .responsive-svg {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    overflow: hidden;
    position: relative;
    height: 100%;
    &:before {
      background-image: url(${XiQLightLogo});
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      left: 0;
      content: "";
      position: absolute;
      height: 63%;
      width: 100%;
    }
    svg {
      width: 100%;
      height: 100%;
      defs {
        linearGradient {
          stop {
            stop-color: #e9e9e9 !important;
            &:nth-of-type(2) {
              stop-color: #f6f6f6 !important;
            }
          }
        }
      }
    }
    &.type-2 {
      height: auto;
      width: 100%;
      &:before {
        background-size: 60px;
        top: 15px;
        left: 15px;
        height: calc(100% - 30px);
        min-width: 95px;
        width: 20%;
      }
    }
    &.type-3 {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0px;
      height: auto;
      &:before {
        background-size: 60%;
        top: 15px;
        left: 0;
        height: calc(100% - 25px);
        width: 11%;
      }
    }
  }
  .small-three {
    height: 100%;
    flex-flow: column wrap;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
  }
`;
